export type MenuItem = {
  key?: string
  label?: string
  icon?: string
  link?: string
  collapsed?: boolean
  subMenu?: any
  isTitle?: boolean
  badge?: any
  parentKey?: string
  disabled?: boolean
  permission?: string[]
  fake?: boolean
}

export const MENU: MenuItem[] = [
  {
    key: 'general',
    label: 'MENU',
    isTitle: true,
  },
  {
    key: 'dashboard-1',
    icon: 'fa-solid fa-chart-line',
    label: 'Dashboard 1',
    link: '/dashboard-1',
  },
  {
    key: 'dashboard-2',
    icon: 'fa-solid fa-chart-pie',
    label: 'Dashboard 2',
    link: '/dashboard-2',
  }
]
